

window.cdnUrl =  'https://acorn-cdn.azureedge.net/';
window.interval;
window.liveviewHost = "https://liveview.3dprinteros.com";
window.img_url = "/get-image/";
window.site_url = "https://acorn.3dprinteros.com";
window.as3Url  =  process.env.VUE_APP_STORAGE;
window.fileCreateTypes = {"1":"Website Upload","2":"API Upload","4":"Default file","5":"Some other external upload","3":"Created by AppEngine","6":"Upload by Search","7":"Upload by Plugin","8":"Website Copy"};
window.userSlicerSettings = {"disable_slicer_settings":false,"hide_advanced_tab":false,"hide_expert_tab":false,"default_slicer":null,"limits":{"fill_density":null,"wall_thickness":null,"brim_line_count":null},"no_slicers":false,"rm_emptyprinter":null,"nodefault":null};
window.slicerNames = {"48":"Slicer for Makerbots","51":"Slicer 3","3":"Cloud Slicer"};
window.dualExtrudersId = [2,5,6,7,16,17,47,195,207,212,219,228,232,233,239,246,250];
window.printSettings = {"canprint_rs":null,"canqueue_im":null,"confirm_build_tray_is_empty":null};


export default {

}
